import { contactTab, type AccessLevel } from '@ehr/shared';

/**
 * ehr#730 (Share & Access V11: "View tabs lose Add and Edit"; merge note 2: each tab's Add / Edit /
 * Delete buttons check that tab's level). Can the person change what this drawer tab shows? Edit
 * can; View can only on a tab whose top level is View (Messages, which opens in Credify Messaging,
 * where View is everything the tab offers). The server refuses the same writes.
 */
export function tabWritable(key: string, level: AccessLevel): boolean {
  if (level === 'edit') return true;
  return level === 'view' && contactTab(key)?.lockMax === 'view';
}

/** The task fields that say whose it is. */
export interface TaskPeople {
  createdById?: string | null;
  assignees?: readonly { userId: string }[];
  sharedWith?: readonly string[];
}

/**
 * A task's own people (its creator, assignees and the people it is shared with) keep changing it on
 * a View Tasks tab, as on the Tasks page; the server lets them (tasks.route taskContact).
 */
export function ownTask(t: TaskPeople, userId: string | null | undefined): boolean {
  if (!userId) return false;
  return (
    t.createdById === userId ||
    !!t.assignees?.some((a) => a.userId === userId) ||
    !!t.sharedWith?.includes(userId)
  );
}
